import intlTelInput from 'intl-tel-input';

(function ($) {
    const input = $("input[name=Phone]")[0];

    intlTelInput(input, {
        initialCountry: "auto",
        geoIpLookup: function (success, failure) {
            $.get("https://ipinfo.io", function () {
            }, "jsonp").always(function (resp) {
                var countryCode = (resp && resp.country) ? resp.country : "us";
                success(countryCode);
            });
        },
    });

    $("form").submit(function (event) {
        setTimeout(function () {
            $("form").removeClass('sent');
            console.log('mail_send');
        }, 2000)
    });

})(jQuery);